export const AppRoutes = {
  HOME: { route: '/', name: 'home' },
  ABOUT: { route: '/about', name: 'about' },
  WORKS: { route: '/portfolio', name: 'portfolio' },
  // BLOGS: { route: '/blogs', name: 'blogs' },
  JOBS: { route: '/jobs', name: 'careers' },
  CONTACT_US: { route: '/contact-us', name: 'contact' },
};
